<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="targetMonth"
              label="対象年月"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="monthForPicker"
            type="month"
            @input="menu = false"
            locale="jp-ja"
            no-title
            scrollable
            @change="onChangeMonth()"
          >
            <v-spacer></v-spacer>
          </v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-card>
      <v-container fluid grid-list-xl>
        <v-card-title>月間販売実績データアップロード</v-card-title>
        <v-layout row wrap>
          <v-flex xs6>
            <v-autocomplete
              v-model="partnerCode"
              :items="partnerList"
              label="取引先"
              item-text="brandName"
              item-value="brandId"
              prepend-icon="business"
              clearable
              :loading="partnerLoading"
              :disabled="partnerLoading"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              v-model="fixedOfficialStoreCode"
              label="基幹店舗コード"
              prepend-icon="store"
              hint="単一店舗でExcel本文に店舗コードがない場合のみ使用"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field 
              label="販売実績データ"
              @click="pickFile"
              v-model="fileName"
              prepend-icon="attach_file"
              hint="CSVまたはExcelファイル"
            ></v-text-field>
            <input
              accept=".xls,.xlsx"
              type="file"
              ref="file"
              style="display: none"
              value="データアップロード"
              @change="onFileChange($event)"
            />
          </v-flex>

          <v-flex xs3 align-self-center>
            <v-btn block color="info" dark :loading="loading" @click="upload()">
              <v-icon dark left>mdi-upload</v-icon>アップロード
            </v-btn>
            <v-btn block @click="clear()">
              <v-icon dark left>mdi-refresh</v-icon>クリア
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-flex xs12>
      <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
        <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
      </v-btn>
    </v-flex>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'

export default {
  created() {
  ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

  this.partnerLoading = true

  ServerApiCallService.brands()
    .then(response => {
      const brands = response.data.brands || []

      console.log("brands>>>>>>>>>>>>>>", brands);
      

      this.partnerList = brands.filter(brand => {
        return String(brand.status) === '1'
      })
    })
    .catch(error => {
      console.log('There was an error:', error.response || error)
    })
    .finally(() => {
      this.partnerLoading = false
    })
  },
  methods: {
    onChangeMonth() {
      console.log('onChangeMonth')

      this.targetMonth = this.monthForPicker.replace(/-/g, '/')
    },    
    onFileChange(e) {
      // const files = e.target.files

      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    pickFile() {
      this.$refs.file.click()
    },
    upload() {
      console.log('upload')

      if (!this.targetMonth) {
        this.$parent.$parent.$parent.showErrorDialog(
          '対象年月を選択してください'
        )
        return
      }

      if (!this.partnerCode) {
        this.$parent.$parent.$parent.showErrorDialog(
          '取引先を選択してください'
        )
        return
      }

      if (!this.targetFile) {
        this.$parent.$parent.$parent.showErrorDialog(
          '取引先の月間販売実績ファイルを選択してください'
        )
        return
      }

      const fileName = this.targetFile.name.toLowerCase()
      if (!fileName.endsWith('.xls') && !fileName.endsWith('.xlsx')) {
        this.$parent.$parent.$parent.showErrorDialog(
          'Excelファイルを選択してください'
        )
        return
      }

      if (!this.fixedOfficialStoreCode) {
        const continueUpload = window.confirm(
          '取引先が単一店舗で、Excel本文に店舗コードがない場合は、基幹店舗コードが必要です。未入力のまま続行しますか？'
        )
        if (!continueUpload) {
          return
        }
      }

      let formData = new FormData()
      formData.append('file', this.targetFile)
      formData.append('partnerCode', this.partnerCode)
      formData.append('targetMonth', this.targetMonth.replace(/\//g, ''))
      if (this.fixedOfficialStoreCode) {
        formData.append('fixedOfficialStoreCode', this.fixedOfficialStoreCode)
      }

      this.loading = true
      ServerApiCallService.uploadSalesExcel(formData)
        .then((response) => {
          this.targetFile = null
          this.$refs.file.value = null
          this.fileName = ''

          this.$router.push({
            name: 'admin/sales-excel-upload-analysis',
            params: {
              analyzeResult: response.data
            }
          })
        })
        .catch((error) => {
          console.log('There was an error:', error)
          this.$parent.$parent.$parent.showErrorDialog(
            'アップロードに失敗しました'
          )
        })
        .finally(() => {
          this.loading = false
        })
    },
    clear() {
      this.targetFile = null
      this.partnerCode = ''
      this.fixedOfficialStoreCode = ''
      this.$refs.file.value = null
      this.fileName = ''
    },
  },
  data() {
    return {
      partnerCode: '',
      fixedOfficialStoreCode: '',
      partnerList: [],
      partnerLoading: false,
      loading: false,
      menu: '',
      targetMonth: '',
      monthForPicker: '',
      targetFile: null,
      fileName: '',
    }
  },
}
</script>
